import {
    CACHE_FRESHNESS_HEADER,
    CACHE_KEY_HEADER,
    CACHE_TAGS_HEADER,
    CACHE_TTL_HEADER
} from '@casumo/fabric-fundamentals';

export const throwNotImplemented = (fnName: string) => {
    throw new Error(`Function ${fnName} is not implemented in gatekeeper legacy mode`);
};

type TCacheDataFromHeaders = {
    key?: string;
    ttl?: number;
    freshness?: number;
    tags?: string[];
};

export function getCacheHeadersValues(headers: Headers): TCacheDataFromHeaders {
    if (!headers) return {};

    const key = headers.get(CACHE_KEY_HEADER);
    if (!key) return {};

    const ttlFromCache = Number(headers.get(CACHE_TTL_HEADER)); // in seconds
    const ttl = isNaN(ttlFromCache) ? undefined : ttlFromCache * 1000; // in milliseconds
    const freshnessFromCache = Number(headers.get(CACHE_FRESHNESS_HEADER));
    let freshness = isNaN(freshnessFromCache) ? undefined : freshnessFromCache * 1000;
    const tags = (headers.get(CACHE_TAGS_HEADER)?.split(',') || []).map((s: string) => s.trim());

    if (freshness && ttl && freshness >= ttl) {
        freshness = undefined;
        console.error(
            `${key} Freshness (${freshness}) is greater than TTL (${ttl}). Unsetting freshness.`
        );
    }

    return {
        key,
        ttl,
        ...(freshness ? { freshness } : undefined),
        ...(tags.length ? { tags } : undefined)
    };
}

export function cleanUpCacheHeaders(headers: Headers): void {
    headers.delete(CACHE_KEY_HEADER);
    headers.delete(CACHE_TTL_HEADER);
    headers.delete(CACHE_TAGS_HEADER);
    headers.delete(CACHE_FRESHNESS_HEADER);
}
